import React, { useState, useEffect } from "react";

import {
  Box,
  Grid,
  Button,
  ButtonGroup,
  FormLabel,
  LinearProgress,
  Fade,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";

// Context
import fondoBlanco from "../../assets/fondoblanco.jpg";
import { useSearchParams } from "react-router-dom";
import api from "../../api/axios";

const Ver = () => {
  const { goEdit, goTable } = useLocationHelpers();

  const [searchParams] = useSearchParams();
  const associationId = searchParams.get("id");

  const [companyData, setCompanyData] = useState({});

  const [asocData, setAsocData] = useState({
    asocAcuerdo: "",
    asocAddress: "",
    asocCif: "",
    asocContactname: "",
    asocEmail: "",
    asocGrupo: "",
    asocName: "",
    asocNotifications: "",
    asocObservaciones: "",
    asocPhone: "",
    asocPostalcode: "",
    asocProvince: "",
    asocCompany: "",
  });

  const [flag, setFlag] = useState(false);

  // Obtener los datos del usuario
  const getData = async () => {
    setFlag(true);
    const url = `${process.env.REACT_APP_API_URL}/associations/show`;

    try {
      const response = await api.post(url, { id: associationId });
      console.log(response);

      const {
        asoc_acuerdo,
        asoc_address,
        asoc_cif,
        asoc_contactname,
        asoc_email,
        asoc_grupo,
        asoc_name,
        asoc_notifications,
        asoc_observaciones,
        asoc_phone,
        asoc_postalcode,
        asoc_province,
        company_id,
        company_relation,
        group_relations,
      } = response.data.association[0];

      setCompanyData(company_relation || {});

      setAsocData({
        // asocAcuerdo: asoc_acuerdo,
        asocAddress: asoc_address,
        asocCif: asoc_cif,
        asocContactname: asoc_contactname,
        asocEmail: asoc_email,
        asocGrupo: group_relations.grupo,
        asocName: asoc_name,
        // asocNotifications: asoc_notifications,
        asocObservaciones: asoc_observaciones,
        asocPhone: asoc_phone,
        asocPostalcode: asoc_postalcode,
        asocProvince: asoc_province,
      });
    } catch (error) {
      console.error("Error fetching user data:", error); // Mensaje de error más descriptivo
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  useEffect(() => {
    getData();
  }, [associationId]);

  const ImageCell = () => {
    // const { userData } = useContext(UserContext);
    // Verifica que `asocData.userCompany` y `asocData.userCompany.company_logo` existan antes de usarlos
    const imageUrl =
      companyData?.id && companyData?.company_logo // Verifica que existan `id` y `company_logo`
        ? `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${companyData.id}/${companyData.company_logo}` // Usa la imagen original si está disponible
        : fondoBlanco; // Si no hay imagen, el valor será null

    return (
      <img
        src={imageUrl} // Usa una imagen de reemplazo si `imageUrl` es null
        alt="User logo"
        className="image-views"
      />
    );
  };

  const labels = {
    // asocAcuerdo: "Acuerdo",
    asocAddress: "Dirección",
    asocCif: "CIF",
    asocContactname: "Nombre de Contacto",
    asocEmail: "Email",
    asocGrupo: "Grupo",
    asocName: "Nombre",
    // asocNotifications: "Notificaciones",
    asocObservaciones: "Observaciones",
    asocPhone: "Teléfono",
    asocPostalcode: "Código Postal",
    asocProvince: "Provincia",
    asocCompany: "Empresa",
  };

  useEffect(() => {
    console.log(asocData); // Esto se ejecutará cada vez que asocData cambie
  }, [asocData]);

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Asociaciones" subTitle="Ver" />
      <Fade
        in={!flag && asocData && Object.entries(asocData).length > 0}
        timeout={800}>
        <div className="formMainContainer">
          {!flag && (
            <Grid
              container
              style={{ textAlign: "center" }}
              p={2}
              className="fontSize">
              <Grid item xs={12} md={4} className="image-view-container">
                {ImageCell()}
              </Grid>
              {!flag && asocData && Object.entries(asocData).length > 0 && (
                <Grid container item xs={12} md={8} textAlign={"left"}>
                  {Object.entries(asocData).map(([key, value]) => (
                    <Grid item xs={12} textAlign={"left"} key={key}>
                      <FormLabel>
                        <b>{`${labels[key]}:`}</b> {`${value}`}
                      </FormLabel>
                    </Grid>
                  ))}
                </Grid>
              )}
              <Grid item xs={12}>
                <ButtonGroup
                  sx={{
                    width: "100%",
                    justifyContent: "center",
                    textAlign: "center",
                    margin: "20px auto 0px auto",
                  }}>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() =>
                      goEdit("asociaciones", associationId, "Asociación")
                    }
                    variant="outlined"
                    color="success">
                    Editar
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() => goTable("asociaciones", "Asociaciones")}
                    variant="outlined"
                    color="error">
                    Tabla
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default Ver;
